var ProgramTypeVariants = /* @__PURE__ */ ((ProgramTypeVariants2) => {
  ProgramTypeVariants2["IN_WAREHOUSE"] = "inWarehouse";
  ProgramTypeVariants2["LOCATION_CONTROLLED_INVENTORY"] = "locationControlledInventory";
  ProgramTypeVariants2["LTL_PICKUP"] = "ltlpickup";
  ProgramTypeVariants2["SITE_CONTROLLED_INVENTORY"] = "siteControlledInventory";
  ProgramTypeVariants2["TWO_DAY_DELIVERY"] = "2DayDelivery";
  ProgramTypeVariants2["STANDARD_DELIVERY"] = "standardDelivery";
  ProgramTypeVariants2["SAME_DAY_DELIVERY"] = "sameDayDelivery";
  ProgramTypeVariants2["THIRD_PARTY_DELIVERY"] = "3rdPartyDelivery";
  ProgramTypeVariants2["GOOGLE_GROCERRY"] = "googleGrocery";
  ProgramTypeVariants2["USE_WAREHOUSE_INVENTORY"] = "useWarehouseInventory";
  ProgramTypeVariants2["LOCAL"] = "local";
  ProgramTypeVariants2["STANDARD"] = "standard";
  ProgramTypeVariants2["NATIONAL"] = "national";
  ProgramTypeVariants2["WAREHOUSE"] = "warehouse";
  ProgramTypeVariants2["COSTCOGROCERY"] = "CostcoGrocery";
  ProgramTypeVariants2["SHIP_IT"] = "ShipIt";
  ProgramTypeVariants2["WAREHOUSE_DELIVERY"] = "WarehouseDelivery";
  return ProgramTypeVariants2;
})(ProgramTypeVariants || {});
var StockVariants = /* @__PURE__ */ ((StockVariants2) => {
  StockVariants2["IN_STOCK"] = "INSTOCK";
  StockVariants2["LOW_STOCK"] = "LOWSTOCK";
  StockVariants2["NO_STOCK"] = "NOSTOCK";
  return StockVariants2;
})(StockVariants || {});
var WarehouseChannelBadgeStatus = /* @__PURE__ */ ((WarehouseChannelBadgeStatus2) => {
  WarehouseChannelBadgeStatus2["IN_STOCK_PICK_UP"] = "in-stock-pick-up";
  WarehouseChannelBadgeStatus2["IN_STOCK_IN_WAREHOUSE"] = "in-stock-in-warehouse";
  WarehouseChannelBadgeStatus2["OUT_OF_STOCK"] = "out-of-stock";
  WarehouseChannelBadgeStatus2["LOW_STOCK_IN_WAREHOUSE"] = "low-stock-in-warehouse";
  WarehouseChannelBadgeStatus2["SEE_PRODUCT_DETAILS"] = "see-product-details";
  WarehouseChannelBadgeStatus2["SHIPS_TO_WAREHOUSE"] = "ships-to-warehouse";
  WarehouseChannelBadgeStatus2["IN_STOCK_MDO_PICK_UP"] = "in-stock-mdo-pick-up";
  return WarehouseChannelBadgeStatus2;
})(WarehouseChannelBadgeStatus || {});
var DeliveryStatus = /* @__PURE__ */ ((DeliveryStatus2) => {
  DeliveryStatus2["Available"] = "available";
  DeliveryStatus2["ComingSoon"] = "coming-soon";
  DeliveryStatus2["OutOfStock"] = "out-of-stock";
  DeliveryStatus2["Unavailable"] = "unavailable";
  DeliveryStatus2["ViaInstacart"] = "via-instacart";
  return DeliveryStatus2;
})(DeliveryStatus || {});
var ProductFulfillmentCategories = /* @__PURE__ */ ((ProductFulfillmentCategories2) => {
  ProductFulfillmentCategories2["WAREHOUSE"] = "warehouse";
  ProductFulfillmentCategories2["ONLINE"] = "online";
  return ProductFulfillmentCategories2;
})(ProductFulfillmentCategories || {});
export {
  DeliveryStatus,
  ProductFulfillmentCategories,
  ProgramTypeVariants,
  StockVariants,
  WarehouseChannelBadgeStatus
};
